import {useEffect, useRef} from 'react';
export default function useVisibleRefresh(refresh, enabled = true) {
    const latest = useRef(refresh);
    latest.current = refresh;
    useEffect(() => {
        if (!enabled) return;
        let busy = false, disposed = false;
        const run = async () => {
            if (disposed || busy || document.visibilityState !== 'visible') return;
            busy = true;
            try { await latest.current(); } catch (error) { console.error('Обновление кабинета', error); }
            finally { busy = false; }
        };
        window.addEventListener('focus', run);
        document.addEventListener('visibilitychange', run);
        const timer = setInterval(run, 30000);
        return () => {disposed = true;clearInterval(timer);window.removeEventListener('focus', run);document.removeEventListener('visibilitychange', run);};
    }, [enabled]);
}